module.exports = __webpack_public_path__ + "img/jornay-logo-mobile.71fe5c04.svg";